import { ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { CoreCustomPageType, CorePageReviewRendererType } from '../../../class/workflow.type';
import { workflowPageRegistry } from '../../shared/workflow-registries';
import { FlowInstance } from '@workflow/class/flow.service';
import { PageInstance } from '@workflow/class/page.service';

export class PageResolveHelper {
  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly pageContainer: ViewContainerRef,
    private readonly page: PageInstance,
    private readonly flow: FlowInstance
  ) {}

  public resolve<T>(type: CoreCustomPageType | CorePageReviewRendererType): ComponentRef<T> {
    const pageInstance = workflowPageRegistry[type];
    if (!pageInstance) {
      throw new Error(`No Page has been registered for type '${type}' in page id '${this.page.id}'. `);
    }

    const factory = this.componentFactoryResolver.resolveComponentFactory(pageInstance);
    return this.pageContainer.createComponent(factory) as ComponentRef<T>;
  }
}
